import { pickBy, identity } from "lodash"

class PostCreateDynamicChannelsRequest {

    constructor({
        communityId,
        entityType,
        channelTypeId,
        channelValues,
    }) {
        this.communityId = communityId
        this.entityType = entityType
        this.channelTypeId = channelTypeId
        this.channelValues = channelValues
    }

    getPayload = () => {
        
        const payload = {
            "community_id": this.communityId,
            "entity_type": this.entityType,
            "channel_type_id": this.channelTypeId,
            "channel_values": this.channelValues,
        }

        return pickBy(payload, identity)
    }
    
}

export default PostCreateDynamicChannelsRequest
